import styles from "../../styles/PLMApp.module.css";
// src/components/plm/DocumentCenter.jsx

import { useState } from "react";

import { useDocuments } from "../../hooks/hooks";
import { DOC_TAGS } from "../../data/constants";
import { getFileIcon, formatDate } from "../../utils/utils";

export default function DocumentCenter({ supplierId, orderId }) {
  const [search, setSearch] = useState("");
  const [activeTag, setActiveTag] = useState("All");

  const allDocs = useDocuments(supplierId, orderId, null);

  const filtered = allDocs.filter((d) => {
    const matchTag = activeTag === "All" || d.tag === activeTag;
    const matchSearch =
      !search || d.name.toLowerCase().includes(search.toLowerCase());
    return matchTag && matchSearch;
  });

  return (
    <div className={styles.docCenter}>
      <div className={styles.docSearchBar}>
        <input
          type="text"
          className={styles.searchInput}
          placeholder="Search documents…"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      <div className={styles.docTagFilter}>
        {DOC_TAGS.map((t) => (
          <button
            key={t}
            className={`${styles.docTag} ${
              activeTag === t ? styles.docTagActive : ""
            }`}
            onClick={() => setActiveTag(t)}
          >
            {t}
          </button>
        ))}
      </div>

      {filtered.length === 0 ? (
        <div className={styles.emptyState}>
          <div className={styles.emptyStateIcon}>📁</div>
          <div className={styles.emptyStateText}>
            No documents yet. Upload files from any workflow step.
          </div>
        </div>
      ) : (
        <div className={styles.docGrid}>
          {filtered.map((d) => (
            <a
              key={d.id}
              href={d.url}
              target="_blank"
              rel="noreferrer"
              style={{ textDecoration: "none" }}
            >
              <div className={styles.docCard}>
                <div className={styles.docCardTag}>{d.tag}</div>
                <div className={styles.docCardIcon}>{getFileIcon(d.name)}</div>
                <div className={styles.docCardName}>{d.name}</div>
                <div className={styles.docCardMeta}>
                  {d.categoryId && <div>{d.categoryId}</div>}
                  <div>{formatDate(d.uploadedAt)}</div>
                  {d.size && <div>{Math.round(d.size / 1024)} KB</div>}
                </div>
              </div>
            </a>
          ))}
        </div>
      )}
    </div>
  );
}
